import { createReducer, updateState } from 'redux/handlers'
import types from './types'

const initialState = {
  processDetail: {},
  modalActionRef: {},
  actionDetail: {},
  actionsErrors: {},
  modalLoading: false,
  modalError: null,
  loading: false,
  error: null
}

const getProcessDetail = (state, action) => updateState(state, { processDetail: action.payload })

const updateModalActionRef = (state, action) => updateState(state, { modalActionRef: action.payload })

const setActionDetail = (state, action) => updateState(state, { actionDetail: action.payload })

const updateActionsErrors = (state, action) => updateState(state, { actionsErrors: action.payload })

const updateModalLoading = (state, action) => updateState(state, { modalLoading: action.payload })

const updateModalError = (state, action) => updateState(state, { modalError: action.payload })

const updateLoading = (state, action) => updateState(state, { loading: action.payload })

const updateError = (state, action) => updateState(state, { error: action.payload })

export default createReducer(initialState, {
  [types.SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL]:      getProcessDetail,
  [types.SMARTCHAT_DETAILS_UPDATE_MODAL_ACTION_REF]:    updateModalActionRef,
  [types.SMARTCHAT_DETAILS_SET_ACTION_DETAIL]:          setActionDetail,
  [types.SMARTCHAT_DETAILS_UPDATE_ACTIONS_ERRORS]:      updateActionsErrors,
  [types.SMARTCHAT_DETAILS_UPDATE_MODAL_LOADING]:       updateModalLoading,
  [types.SMARTCHAT_DETAILS_UPDATE_MODAL_ERROR]:         updateModalError,
  [types.SMARTCHAT_DETAILS_UPDATE_LOADING]:             updateLoading,
  [types.SMARTCHAT_DETAILS_UPDATE_ERROR]:               updateError
})
